/* global window */

import React, { Component } from "react";

// third party
import moment from "moment";

// components
import CardTitlePart from "../../parts/CardTitlePart";
import HtmlPart from "../../parts/HtmlPart";

class _DeliveryInfoCard extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      title,
      titleColour,
      bodyText,
      orderRef,
      orderNo,
      readyFrom,
    } = this.props;

    const dateString = readyFrom
      ? moment(readyFrom.replace(/[^a-z0-9()]/gi, ""))
      : null;

    const estimatedDate = `${
      dateString ? dateString.format("DD/MM/YY") : "Unknown"
    }`;

    const bodyTextString = bodyText ? (
      <div className="u-padding-medium u-padding-top-small u-padding-bottom-small">
        <HtmlPart htmlString={bodyText} ommitBaseStyles={true} />
      </div>
    ) : (
      ""
    );

    return (
      <div className="flow-card">
        <div className="d-delivery-card">
          <header>Important Order Update</header>

          <div className="u-material-shadow-1 c-event-feed__card">
            <section>
              <CardTitlePart backgroundColor={titleColour} title={title} />

              <div className="u-pale-grey-bg u-padding-small u-text-center">
                <p>{bodyTextString}</p>
              </div>

              <div className="u-padding-bottom-small u-text-center c-event-feed__card__extra-info">
                <strong>Order Number:</strong> {`${orderRef}/${orderNo}`}
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default _DeliveryInfoCard;



// WEBPACK FOOTER //
// ./src/cards/templates/DeliveryInfoCard.js